import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import {VccPaymentGateway} from '../model/vcc-payment-gateway';
import {UpsertVccRequest} from '../model/upsert-vcc-request';
import {UpsertVccResponse} from '../model/upsert-vcc-response';
import {DeleteVccRequest} from '../model/delete-vcc-request';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayService {
    private dbov2ResourcePath: string = 'dbov2/payment-gateway';

    constructor(private httpClient: HttpClient) {
    }

    errorHandler(error: HttpErrorResponse) {
      return throwError(error.message || 'server Error');
    }

    public getDbov2VccPaymentGatewayInfoById(id: number, purchasedCardGuid: string, appId: string): Observable<VccPaymentGateway> {
      let httpParams = new HttpParams();
      if (id != null) {
        httpParams = httpParams.set('VccId', id);
      }
      if (purchasedCardGuid != null) {
        httpParams = httpParams.set('PurchasedCardGuid', purchasedCardGuid);
      }
      httpParams = httpParams.set('ApplicationId', appId);
      return this.httpClient
        .get<VccPaymentGateway>(this.dbov2ResourcePath, {params: httpParams})
        .pipe(catchError(this.errorHandler));
    }

    public createDbov2PaymentGatewayVccService(issueVcc: UpsertVccRequest): Observable<UpsertVccResponse> {
      return this.httpClient
        .post<UpsertVccResponse>(this.dbov2ResourcePath, JSON.stringify(issueVcc));
    }

    public updateDbov2PaymentGatewayVccService(updateVcc: UpsertVccRequest): Observable<UpsertVccResponse> {
      return this.httpClient
        .put<UpsertVccResponse>(this.dbov2ResourcePath, JSON.stringify(updateVcc));
    }

    public deleteDbov2PaymentGatewayVccService(deleteVcc: DeleteVccRequest){
      return this.httpClient
        .delete<any>(this.dbov2ResourcePath, { body: JSON.stringify(deleteVcc)});
    }
}
